<template>
	<footer>
		<div class="foot-nav-container pc_padding">
			<div class="footer-about">
				<div class="footer-item-title">About us</div>
				<div class="footer-item-content">{{ domainConfig.aboutUs }}</div>
			</div>
			<div class="footer-side-row">
				<div class="footer-side-resource">
					<div class="footer-item-title">Resources</div>
					<div class="footer-item-content resource">
						<div
							class="footer-item-content-item cursor"
							@click="gotoFeedBack">
							Feedback
						</div>
						<div
							class="footer-item-content-item cursor"
							@click="goto('terms-of-services')">
							Terms of services
						</div>
						<div
							class="footer-item-content-item cursor"
							@click="goto('privacy')">
							Privacy policy
						</div>
						<div
							class="footer-item-content-item cursor"
							@click="goto('disclaimer')">
							Disclaimer
						</div>
					</div>
				</div>
				<div class="footer-side-contact">
					<div class="footer-item-title">Contact us</div>
					<div class="footer-item-content">
						<a
							class="footer-item-content-item"
							:href="`mailto:${domainConfig.webEmail}`">
							{{ domainConfig.webEmail }}
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="corner-module pc_padding">Copyright © {{ new Date().getFullYear() }} {{ domainConfig.webUrl }}. All Rights Reserved.</div>
	</footer>
</template>

<script>
export default {
	name: 'FootModule1',
	methods: {
		goto(where) {
			console.log(this.$route.path)
			this.$router.push({ name: where })
		},
		gotoFeedBack() {
			window.open('https://forms.gle/Jfh2cL1kBhP4DtCG8', '_blank', 'resizable,scrollbars,status')
		},
	},
}
</script>
<style lang="scss" scoped>
footer {
	background: #333;
}
.footer-item-title {
	color: #fff;
	font-family: 'Roboto';
	font-size: rem(30);
	font-style: normal;
	font-weight: 600;
	line-height: normal;
}
.footer-item-content {
	margin-top: rem(30);
	color: #fff;
	font-family: 'Roboto';
	font-size: rem(26);
	font-style: normal;
	font-weight: 400;
	line-height: rem(40); /* 153.846% */
	a {
		color: #fff;
	}
}
.corner-module {
	border-top: 1px solid rgba(#c6c6c6, 0.4);
	color: rgba(255, 255, 255, 0.6);
	text-align: center;
	font-family: 'Roboto';
	font-size: rem(18);
	font-style: normal;
	font-weight: 400;
	line-height: rem(35); /* 194.444% */
}
@media screen and (orientation: landscape) {
  .pc_padding {
		margin: 0 auto;
		width: rem(1200);
		box-sizing: border-box;
	}
	.foot-nav-container {
		display: flex;
		align-items: flex-start;
		justify-content: space-around;
		padding: rem(60) 0 rem(40);
	}
	.footer-item-content {
		&.resource {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: rem(30);
		}
	}
	.footer-side-row {
		display: flex;
		flex-direction: column;
		gap: rem(60);
	}
	.footer-about {
		width: rem(410);
	}
	.corner-module {
		padding: rem(40) rem(200) rem(30);
	}
}
@media screen and (orientation: portrait) {
	.pc_padding {
		margin: 0 auto;
		width: 100vw;
		box-sizing: border-box;
	}
	.footer-about {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: rem(35) rem(50);
	}
	.footer-item-content {
		&.resource {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: rem(30);
		}
	}
	.footer-side-resource {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: rem(31) 0;
		border-top: 1px solid rgba(#c6c6c6, 0.4);
	}
	.footer-side-contact {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: rem(28) 0;
		border-top: 1px solid rgba(#c6c6c6, 0.4);
	}
	.corner-module {
		padding: rem(24) rem(120);
	}
}
</style>